import { render, staticRenderFns } from "./2D-game.vue?vue&type=template&id=392bdfb2"
import script from "./2D-game.vue?vue&type=script&lang=js"
export * from "./2D-game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports